/* NODE Triton — mega menu abre no hover (desktop); clique segue funcionando (touch) */
if (!window.__ndHeaderLoaded) {
  window.__ndHeaderLoaded = true;
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('.header__inline-menu details').forEach((d) => {
      let timer;
      const host = d.parentElement;
      host.addEventListener('mouseenter', () => {
        clearTimeout(timer);
        if (!d.hasAttribute('open')) {
          d.setAttribute('open', '');
          const s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'true');
        }
      });
      host.addEventListener('mouseleave', () => {
        timer = setTimeout(() => {
          d.removeAttribute('open');
          const s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }, 120);
      });
    });
  });
}
